<template>
    <div class="hidden lg:block relative">
        <div class="splide" id="dashboard-slide-big">
            <div class="splide__track">
                <ul class="splide__list">
                    <li class="splide__slide cursor-pointer"
                        v-for="(dashboard, k) in dashboardList"
                        :key="k"
                        @click="clickDashboard(dashboard)">
                        <img class="w-full" :data-splide-lazy="dashboard.imageUrl">
                    </li>
                </ul>
            </div>
        </div>

        <div class="absolute top-0 left-0 h-full flex">
            <img class="my-auto h-20" src="@/assets/dashboard/btn-prev.svg" @click="btnPrev()" />
        </div>
        <div class="absolute top-0 right-0 h-full flex">
            <img class="my-auto h-20" src="@/assets/dashboard/btn-next.svg" @click="btnNext()" />
        </div>
    </div>
</template>
<script>
//library
import Splide from '@splidejs/splide'; //https://splidejs.com/

export default {
    props: {
        dashboardList: { type: Array, required: true },
    },
    data: function () {
        return {
            slider: null,
            currentSliderIndex: 0,
        };
    },
    mounted: function () {
        this.setSlider();
    },
    methods: {
        clickDashboard: function(dashboard) {
            if (dashboard.type == 'link') {
                if (dashboard.url.includes('http')) {
                    window.open(dashboard.url, '_blank');
                } else {
                    this.$router.push('/' + dashboard.url);
                }
            } else if (dashboard.type == 'campaign') {
                this.$router.push('/product/' + dashboard.id);
            } else if (dashboard.type == 'bzbs_cat' || dashboard.type == 'cat') {
                if (dashboard.cat == "rewards") {
                    this.$router.push('/reward');
                } else {
                    this.$router.push('/home/' + dashboard.cat);
                }
            }
        },
        setSlider: function() {
            this.$nextTick(() => {
                this.slider = new Splide('#dashboard-slide-big', {
                    type: 'loop',
                    arrows: false,
                    lazyLoad: true,
                    autoplay: true,
                    interval: 5000,
                }).mount();
                this.slider.on('move', (newIndex) => {
                    this.currentSliderIndex = newIndex;
                });
            });
        },

        btnNext: function() {
            let next = this.currentSliderIndex + 1;
            this.slider.go(next);
        },
        btnPrev: function() {
            let prev = this.currentSliderIndex - 1;
            this.slider.go(prev);
        },
    },
}
</script>
<style lang="scss">
    #dashboard-slide-big {
        .splide__pagination {
            bottom: -20px;

            .splide__pagination__page {
                background: #cccccc;
                width: 8px;
                height: 8px;

                &.is-active {
                    background: #502314;
                    transform: scale(1.2);
                }
            }
        }
    }
</style>
